import { render, staticRenderFns } from "./HistoryRequest.vue?vue&type=template&id=74f88e99&scoped=true"
import script from "./HistoryRequest.vue?vue&type=script&lang=js"
export * from "./HistoryRequest.vue?vue&type=script&lang=js"
import style0 from "./HistoryRequest.vue?vue&type=style&index=0&id=74f88e99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f88e99",
  null
  
)

export default component.exports